import * as React from 'react';

import StatusLabel from 'components/status-label/StatusLabel';

import { __t, applyTranslations } from 'utils/language';

import type { ProposalListMemberStatus, StatusLabelType } from 'types';

applyTranslations(require('./creator-proposal-status.i18n.json'));

type Props = {
  status: ProposalListMemberStatus
};

const StatusPill = ({
  status
}: Props) => {
  const typeMapping: Record<ProposalListMemberStatus, StatusLabelType> = {
    incomplete: 'neutral',
    pending: 'warning',
    approved: 'success',
    declined: 'danger'
  };

  return (
    <StatusLabel
      type={typeMapping[status]}
      size="small"
      label={__t(`creator_proposal_status_v2.${status}`)}
    />
  );
};

export default StatusPill;
